import ACTION_TYPES from "../types";

// reducer.js
const INITIAL_STATE = {
	workspaceListData: [],
	templateListData:[],
	selectedWorkspaceId: "",
	currentSelectedWorkspace: {},
	treeLoading: true,
	userWorkspaceTree:[],
	templateTree:[],
	isLoadingComplete:false,
	workspacesExpand:false,
	rowDataEditor:{},
	searchField: [
		{ key: "my workbook", type: false },
		{ key: "shared with me", type: false }
	  ],
	userWorkspaceList : []
}

const workspaceReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case ACTION_TYPES.SET_WORKSPACE_DATA:
			
			return {
				...state,
				selectedWorkspaceId: action.selectedWorkspaceId ? action.selectedWorkspaceId : state.selectedWorkspaceId,
				workspaceListData: action.workspaceListData ? action.workspaceListData : state.workspaceListData,
				templateListData:action.templateListData?action.templateListData:state.templateListData,
				currentSelectedWorkspace: action.currentSelectedWorkspace ? action.currentSelectedWorkspace : state.currentSelectedWorkspace,
				selectedRowData: action.selectedRowData ? action.selectedRowData : state.selectedRowData,
				treeLoading: action.treeLoading,
				selectedRowId: action.selectedRowId,
				rowDataEditor: action.rowDataEditor ?? state.rowDataEditor,
				userWorkspaceList : action.userWorkspaceList ? action.userWorkspaceList : state.userWorkspaceList,
			}

		case ACTION_TYPES.DELETE_WORKSPACE_ITEM:
			let newWorkspaceList = state.workspaceListData.filter((item) => item.id !== action.payload.id)
			return {
				...state,
				workspaceListData: newWorkspaceList,
				selectedWorkspaceId: newWorkspaceList[0] ? newWorkspaceList[0].id : "",
				currentSelectedWorkspace: newWorkspaceList[0] || null,
			}
		case ACTION_TYPES.SET_USERWORKSPACETREE:
			return {
				...state,
				userWorkspaceTree: action.userWorkspaceTree || state.userWorkspaceTree,
				isLoadingComplete: action.isLoadingComplete || state.isLoadingComplete,
			}

		case ACTION_TYPES.SET_TEMPLATE_TREE:
			return {
				...state,
				templateTree: action.templateTree
			};
		case ACTION_TYPES.SET_SEARCHFIELD:
			return {
				...state,
				searchField: action.searchField,
			}
		  case ACTION_TYPES.SET_WORKSPACE_EXPAND:
			return { ...state, workspacesExpand: action.workspacesExpand}

		default:
			return state;
	}
};

export default workspaceReducer;